const fragment = `
  id
  projectBuilding {
    id
  }
  buildingModel {
    id
    name
    imageUrl
    primaryImageUrl
  }
`;

export const listBuildingModelModelsQuery = `
  query ListBuildingModelModels(
    $filter: BuildingModelModelFilterInput
  ) {
    items: listBuildingModelModels(filter: $filter) {
      ${fragment}
    }
  }
`;

export const createBuildingModelModelQuery = `
  mutation CreateBuildingModelModel(
    $input: CreateBuildingModelModelInput!
  ) {
    item: createBuildingModelModel(input: $input) {
      ${fragment}
    }
  }
`;

export const updateBuildingModelModelQuery = `
  mutation UpdateBuildingModelModel(
    $input: UpdateBuildingModelModelInput!
  ) {
    item: updateBuildingModelModel(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteBuildingModelModelQuery = `
  mutation DeleteBuildingModelModel(
    $id: Int!
  ) {
    item: deleteBuildingModelModel(id: $id) {
      ${fragment}
    }
  }
`;
